import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { ElementsPluginInterface } from './definitions';
import { CAPACITOR_ELEMENT_ACTIONS_PLUGIN } from '../pluginConstants';

const ElementActionsPluginRaw = registerPlugin<ElementsPluginInterface>(CAPACITOR_ELEMENT_ACTIONS_PLUGIN);
const ElementActionsPlugin = withBridgedStackTrace(ElementActionsPluginRaw, CAPACITOR_ELEMENT_ACTIONS_PLUGIN);

export * from './definitions';
export { ElementActionsPlugin as ElementsPlugin };
